// IE 2026 09 28 / ODOO-342342: «Бизнес-кейсы» (Use cases) на столе «Путеводитель» — фронт v1. Общее: выключатели, счётчики, консоль, ссылка на кейс.
// Проект: ie-webscm7-2 docs/userdocs-2026-09-25/business_cases_spec_2026-09-28.md (§2.4, §2.5, §5.5–5.7, решения Игоря §8);
// контракт бэка v1: docs/userdocs-2026-09-25/use_cases_api_contract_2026-09-28.md (записи USE-CASE, _doc.items_view, методы widget_USE_CASE).
//
// Из чего состоит фронт (модули utils — без внешних импортов, только соседние utils по относительному пути с .js: store и DOM приходят параметрами,
// логику проверяют юнит-тесты tests/unit/*.test.mjs без сборки):
//   - utils/useCaseMenu.js    — строки _doc.items_view → пункты формы-меню (MenuPanel inline): разделы / этапы — группы, кейсы / пути / шаги —
//                               пункты; бейдж статуса (цвет из строки или словаря STATUS), «Demo check failed», минуты, ▶, ✓, звезда; что делает клик;
//   - utils/guidePersonal.js  — личное: избранное, «пройдено», место в пути — оптимистично, с откатом ключа при ошибке бэка;
//   - utils/guidePath.js      — полоса пути: шаги, «назад / далее», текущий шаг, прогресс;
//   - utils/guidePlay.js      — «Open in demo»: play_plan бэка → стол, страница, чипсы (в памяти, копия «моих» — до), цель; «вернуться к кейсу»,
//                               «вернуть мои фильтры»; вызовы методов widget_USE_CASE;
//   - components_core/AttrUseCaseMenu.vue — вкладка Contents формы кейса (контракт §4.2: attr_type AttrUseCaseMenu, binding _doc.items_view);
//   - components/GuideBar.vue — полоса показа / пути внизу окна; команда стора guide_play.
//
// Выключатели (правило 8 — каждый механизм свой, по умолчанию ВКЛ; override браузера — window.feSettings / ?fe.guide.cases=false в URL):
//   - fe.guide.cases        — весь фронт кейсов. false — как до правки: вкладка Contents (useNew) спрятана, как у прежнего фронта; guide_play ничего не
//                             делает, полосы нет; остальные вкладки формы (About, Used in …) — как их отдаёт бэк;
//   - fe.guide.chipsOnOpen  — «Open in demo» на страницу, которая ещё не открывалась: чипсы якоря ставятся при её открытии, поверх строк стола и ДО
//                             открытия виджетов (store.guideChips_pending → workspace_show_widgets, дальше как у фильтров ссылки), страница грузится один раз;
//                             false — страница открывается с моими чипсами и затем перечитывается с чипсами якоря (два прохода).
//   - fe.guide.tour         — IE 2026 09 30 / ODOO-343435: guided-тур пути (действия tour.actions: подсветка, паспорт ячейки, вкладка, кнопка cta,
//                             заметка с картинкой; режим тура — без записи места / «пройдено»; вход ссылкой ?guide_path=<id>&step=<n>). false — путь
//                             играется как до тура: бэку не объявляется client.use_cases_tour (действия не приходят), отметки пишутся, ссылка игнорируется.
// Консоль: window.guideCases.get() / .set('cases', false) / .set('chipsOnOpen', false) / .set('tour', false) / .reset() / .stats() / .clear() / .session() / .restore() / .end() / .help().

export const FLAG = 'fe.guide.cases'
export const FLAG_CHIPS_OPEN = 'fe.guide.chipsOnOpen'
export const FLAG_TOUR = 'fe.guide.tour'   // IE 2026 09 30 / ODOO-343435
const FLAGS = { cases: FLAG, chipsOnOpen: FLAG_CHIPS_OPEN, tour: FLAG_TOUR }   // IE 2026 09 30 / ODOO-343435: + tour

export const UC_SEGMENT = 'USE-CASE'
export const UC_WORKSPACE = 'workspace-instructions'
export const UC_PAGE = 'page-guide-cases'
export const UC_COMPONENT = 'AttrUseCaseMenu'

const stats = {
    play: 0, playMs: 0,         // «Open in demo» / шаг пути: план получен и выполнен (status ok), сумма времени от клика до конца шагов, мс
    planMs: 0,                  // из них — ожидание ответа play_plan, мс
    denied: 0,                  // not_available — стол / страница недоступны зрителю
    playedHere: 0,              // ODOO-350612: тема показана на текущем экране (без перехода на стол / страницу якоря)
    soon: 0, noAnchor: 0,       // Planned / Idea («скоро»), нечего показать
    playErrors: 0,              // ошибка бэка / нет ответа / шаг не выполнился
    onOpen: 0, inMemory: 0,     // чипсы якоря: при открытии страницы (одна загрузка) / в памяти после перехода
    chipsBackups: 0,            // сохранено «моих» чипсов стола перед показом (по разу на стол)
    chipsRestored: 0,           // «Restore my filters»: столов возвращено
    targetsOpened: 0,           // цель показа открыта (виджет / запись)
    pmSwitched: 0, pmKept: 0,   // ПМ якоря не текущая: переключили / остались на своей
    presenterOnly: 0,           // шагов «только ведущий» показано текстом
    pathSteps: 0,               // переходов по шагам пути (Next / Back)
    backToCase: 0,              // «Back to the case»
    fav: 0, done: 0, pos: 0,    // личные отметки отправлены
    rollbacks: 0,               // из них откатано (бэк не подтвердил)
    localKept: 0,               // IE 2026 09 28 / ODOO-342342 (ревью Н1): бэк не принял отметку — оставлена в браузере (без тоста)
    cancelled: 0,               // IE 2026 09 28 / ODOO-342342 (ревью З3): показов отменено (✕ полосы / новый показ) до конца
    busySkipped: 0,             // IE 2026 09 28 / ODOO-342342 (ревью З8): повторных запусков, пока показ открывается, — пропущено
    chipsKeepHeld: 0,           // IE 2026 09 28 / ODOO-342342 (ревью З4): снимков chipsKeep не записано, пока показ держит чипсы стола (после перезагрузки — «мои»)
    menu: 0, menuMs: 0,         // сборок формы-меню (useCaseMenu_flatten) и их время, мс
    // IE 2026 09 30 / ODOO-343435: guided-тур
    tourMarks: 0,               // подсветок цели поставлено (highlight / open_cell_passport guest)
    tourMissed: 0,              // цель не нашлась на экране — шаг показан текстом без подсветки
    tourFallback: 0,            // ячейка не нашлась — подсвечен виджет целиком
    tourTabs: 0,                // вкладок виджета открыто (open_tab)
    tourClicks: 0,              // паспортов открыто синтетическим кликом (open_cell_passport mode auto)
    tourPassports: 0,           // паспортов открыто путём 🏷 (cellForm_toggle) после синтетического клика (open_cell_passport mode auto) // IE 2026 10 13 / ODOO-343435
    tourNotes: 0, tourCta: 0,   // заметок (tour_note) показано; кнопок cta показано
    tourCtaClicks: 0,           // кликов по кнопкам cta
    tourLinks: 0,               // туров, начатых ссылкой ?guide_path=
    tourPosSkipped: 0,          // шагов тура без записи места в пути (режим тура, marks = false)
    routeMarks: 0,              // demo-webscm 2026 11 02 / ODOO-350612: кружков маршрута навигатора (стол / страница / виджет) поставлено
}

const now = () => (typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now())
const round = (x) => Math.round(x * 10) / 10

export function guideCases_flag(store, name) {
    const key = FLAGS[name] || name
    try { return !(store && typeof store.setting === 'function' && store.setting(key, true) === false) } catch (e) { return true }
}
export function guideCases_on(store) { return guideCases_flag(store, FLAG) }
// IE 2026 09 30 / ODOO-343435: тур — только при включённом фронте кейсов
export function guideCases_tourOn(store) { return guideCases_on(store) && guideCases_flag(store, FLAG_TOUR) }

export function guideCases_count(key, ms) {
    if (!(key in stats)) return
    stats[key]++
    if (ms != null && (key + 'Ms') in stats) stats[key + 'Ms'] = round(stats[key + 'Ms'] + ms)
}
export function guideCases_addMs(key, ms) {
    if (key in stats && ms != null) stats[key] = round(stats[key] + ms)
}
export function guideCases_now() { return now() }
export function guideCases_stats() { return { ...stats } }

// вкладка формы, в которой стоит форма-меню кейсов (контракт §4.2: tabContents, use: false + useNew: true), при выключенном fe.guide.cases —
// спрятана, как у прежнего фронта без компонента (AttrTabPanel.isTabVisible)
export function guideCases_tabHidden(store, attrTab) {
    if (!attrTab || guideCases_on(store)) return false
    const has = (list, d) => (list || []).some(a => a && typeof a === 'object' && (a.attr_type === UC_COMPONENT || a.component === UC_COMPONENT || (d < 3 && has(a.attrs, d + 1))))
    return has(attrTab.attrs, 0)
}

// ссылка на кейс (контракт §1): штатный роутер — стол «Путеводитель», страница Use cases, форма записи
export function guideCases_link(store, id, loc) {
    const dbid = store?.user?.database?.dbid || ''
    const l = loc || (typeof window !== 'undefined' ? window.location : { origin: '', pathname: '/' })
    if (!id || !dbid) return ''
    return `${l.origin}${l.pathname}#/${dbid}?workspace=${UC_WORKSPACE}&page=${UC_PAGE}&open_record=${encodeURIComponent(String(id))}&open_segment=${UC_SEGMENT}`
}

// Консоль: window.guideCases. api — действия стора (сессия показа, вернуть фильтры, закончить), чтобы модуль оставался без импортов
export function guideCases_console(store, api = {}) {
    if (typeof window === 'undefined') return
    const flags = () => Object.fromEntries(Object.entries(FLAGS).map(([k, key]) => [k, guideCases_flag(store, key)]))
    window.guideCases = {
        flags: FLAGS,
        get: () => ({ ...flags(), session: api.session ? api.session() : null, backups: api.backups ? api.backups() : [], stats: { ...stats } }),
        set(name, value) {
            const key = FLAGS[name] || name
            if (!Object.values(FLAGS).includes(key)) return { error: `guideCases: no option '${name}'`, options: Object.keys(FLAGS) }
            window.feSettings?.set?.(key, value)
            return this.get()
        },
        reset() { for (const key of Object.values(FLAGS)) window.feSettings?.unset?.(key); return this.get() },
        stats: () => ({ ...stats }),
        clear() { for (const k of Object.keys(stats)) stats[k] = 0; return { ...stats } },
        session: () => (api.session ? api.session() : null),
        restore: () => (api.restore ? api.restore() : null),
        end: () => (api.end ? api.end() : null),
        help: () => 'guideCases.set("cases", false) — фронт кейсов выключен (вкладка Contents спрятана, полосы нет); guideCases.set("chipsOnOpen", false) — '
            + 'чипсы якоря ставятся после открытия страницы (два прохода); guideCases.set("tour", false) — путь без действий тура и без режима тура; '   // IE 2026 09 30 / ODOO-343435
            + '.restore() — вернуть мои фильтры; .end() — закрыть полосу; .session() — сессия показа; '
            + '.reset() — снять override; .stats() / .clear() — счётчики',
    }
}

// для тестов
export function guideCases__resetForTests() { for (const k of Object.keys(stats)) stats[k] = 0 }
